import axios from "axios";
import { PATH, UPLOAD_PATH, GOOGLE_API_KEY, FATTURE_PATH, FATTURE_API_KEY } from "../constant";

export const ajaxLogin = (url, formData, callback) => {
    fetch(PATH + url, {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => response.json())
        .then((responseJson) => {
            if (callback) {
                callback(responseJson);
            }
        })
        .catch((error) => {
            console.log("error", error);
            //Catch Service Error
        });
};

export const ajaxGetFatture = (url, callback, useDefaultURL = true) => {
    fetch("https://cors-anywhere.herokuapp.com/"+(useDefaultURL ? (FATTURE_PATH) : "") + url, {
        method: "GET",
        headers: {
           "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
            'Content-Type': 'application/json',
            Authorization: `Bearer ${FATTURE_API_KEY}`,
        },
    })
        .then((response) => response.json())
        .then((responseJson) => {
            if (callback) {
                callback(responseJson);
            }
        })
        .catch((error) => {
            console.log(error);
            //Catch Service Error
        });
};


export const ajaxGetStrapiRef = (url, callback, index) => {
    fetch(PATH + url, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${global.jwt}`,
        },
    })
        .then((response) => response.json())
        .then((responseJson) => {
            if (callback) {
                callback(responseJson, index);
            }
        })
        .catch((error) => {
            console.log(error);
            //Catch Service Error
        });
};

export const ajaxGetStrapi = (url, callback) => {
    fetch(PATH + url, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${global.jwt}`,
        },
    })
        .then((response) => response.json())
        .then((responseJson) => {
            if (callback) {
                callback(responseJson);
            }
        })
        .catch((error) => {
            console.log(error);
            //Catch Service Error
        });
};

export const ajaxPostStrapi = (url, formData, callback) => {
    fetch(PATH + url, {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${global.jwt}`,
        },
    })
        .then((response) => response.json())
        .then((responseJson) => {
            if (callback) {
                callback(responseJson);
            }
        })
        .catch((error) => {
            console.log("error", error);
            //Catch Service Error
        });
};

export const ajaxPutStrapi = (url, formData, callback) => {
  fetch(PATH + url, {
    method: "PUT",
    body: JSON.stringify(formData),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${global.jwt}`,
    },
  })
    .then((response) => response.json())
    .then((responseJson) => {
      if (callback) {
        callback(responseJson);
      }
    })
    .catch((error) => {
      console.log(error);
      //Catch Service Error
    });
};

export const ajaxDeleteStrapi = (url, callback = null) => {
  fetch(PATH + url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${global.jwt}`,
    },
  })
    .then((response) => response.json())
    .then((responseJson) => {
      if (callback) {
        callback(responseJson);
      }
    })

    .catch((error) => {
      console.log(error);
      //Catch Service Error
    });
};



export const ajaxUploadImage = (formData, callback) => {
    axios.post(UPLOAD_PATH + "/upload.php", formData).then((res) => {
        if (callback) {
            callback(res.data);
        }
    });
}

export const ajaxGet = (url, callback) => {
    axios.get(UPLOAD_PATH + url).then((res) => {
        if (callback) {
            callback(res.data);
        }
    });
}

export const ajaxPost = (url, formData, callback, errorCallback) => {
    axios.post(UPLOAD_PATH + url, formData).then((res) => {
        if (callback) {
            callback(res.data);
        }
    }).catch((error) => {
        console.error("Errore ajaxPost:", error);
        if (errorCallback) {
            errorCallback(error);
        }
    });
}



export const graphqlGet = (query, callback) => {
  axios({
    url: `${PATH}graphql`,
    method: "post",
    data: {
      query: query,
    },
  }).then((result) => {
    if (callback) {
      callback(result);
    }
  });
};

export const graphqlGetPromise = (query) => {
  return axios({
    url: `${PATH}graphql`,
    method: "post",
    data: {
      query: query,
    },
  });
};

export const getPositionFromAddress = (address, callback, key) => {
    fetch(
        "https://maps.googleapis.com/maps/api/geocode/json?address=" +
        address +
        "&key=" +
        GOOGLE_API_KEY
    )
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson, key);
        });
};

